import {ApolloClient, from, HttpLink, InMemoryCache} from '@apollo/client';
import fetch from 'cross-fetch';
import {onError} from '@apollo/client/link/error';

import {setInfoBoxError} from '@reducers/InfoBoxes';
import {reportError} from '@actions';
import {ENV_ERROR_REPORT} from '@constants/variables';
import responseStatus from '@constants/responseStatuses';

import avcmpConfig from './avcmpConfig';
import possibleTypes from '../config/graphql/possibleTypes.json';
import * as actions from './actions/index';
import configuredStore from './store';

const httpLink = new HttpLink({
    uri: avcmpConfig.apolloClient.networkInterface.uri,
    fetch,
    credentials: 'include',
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
    let reportErrorFlag = false;

    if (graphQLErrors && 0 < graphQLErrors.length) {
        const errorInfo = [];

        graphQLErrors.forEach(({message, locations, path}) => {
            if (500 === errorInfo.code) {
                reportErrorFlag = true;
            }

            return errorInfo.push(`${message}\n${locations}\n${path}`);
        });

        if (!reportErrorFlag) {
            return;
        }

        reportError({
            url: window.location.href,
            previousRoute: configuredStore.getState().app.route.previousRoute,
            error: errorInfo.join('\n\n'),
            user: configuredStore.getState().app.security.user,
            timezone: configuredStore.getState().timezone,
        });

        if (ENV_ERROR_REPORT.includes(process.env.NODE_ENV)) {
            // eslint-disable-next-line
            console.error(`APOLLO ERROR: ${errorInfo}`);
        }


        setInfoBoxError({
            content: 'Error in GraphQL occurred. Log has been sent.',
        });
    }

    if (networkError?.statusCode === responseStatus.HTTP_UNAUTHORIZED) {
        configuredStore.dispatch(actions.sessionEnd());
    }
});


const client = new ApolloClient({
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache({
        possibleTypes,
    }),
    // This line is added because we got warning when running tests with apollo client 3.0.0.
    // We can remove it when we update apollo client to version 3.14.0 or higher.
    // It is related to the fact that in version 3.14.0 of apollo client, the connectToDevTools option is deprecated and replaced with devtools.enabled.
    // So we need to set devtools.enabled to true in development environment to avoid warning.
    // See: https://www.apollographql.com/docs/react/errors#%7B%22version%22%3A%223.14.0%22%2C%22message%22%3A104%2C%22args%22%3A%5B%22ApolloClient%22%2C%22connectToDevTools%22%2C%22Please%20use%20%60devtools.enabled%60%20instead.%22%5D%7D
    devtools: {
        enabled: ('development' === process.env.NODE_ENV),
        name: 'development',
    },
});

export default client;
